import { getRoleValue, hasRoleAccess } from "~shared/utils/role-guard";
import { UserRoleLabels, UserRoles } from "../model/types";
import { useGetUserRoles } from "../api/get-user-roles";


export const useCurrentUserRole = () => {
  const { data: userRolesData, isFetched } = useGetUserRoles();
  
  const staffRoleValue = getRoleValue(userRolesData, UserRoleLabels.STAFF) ?? Number.MAX_SAFE_INTEGER;
  const adminRoleValue = getRoleValue(userRolesData, UserRoleLabels.ADMIN) ?? Number.MAX_SAFE_INTEGER;
  const superAdminRoleValue = getRoleValue(userRolesData, UserRoleLabels.SUPER_ADMIN) ?? Number.MAX_SAFE_INTEGER;
  
  const hasStaffAccess = hasRoleAccess(UserRoles.STAFF, staffRoleValue);
  const hasAdminAccess = hasRoleAccess(UserRoles.ADMIN, adminRoleValue);
  const hasSuperAdminAccess = hasRoleAccess(UserRoles.SUPER_ADMIN, superAdminRoleValue);
  
  return {
    hasStaffAccess,
    hasAdminAccess,
    hasSuperAdminAccess,
    /** False until `/users/roles` has resolved — use before showing role-gated billing UI. */
    isRolesReady: isFetched,
  }; 
};
